/**
 * Transparent-over-hero header.
 *
 * The original site's navbar sits on the hero photograph with white links and
 * the white logo cut, then turns solid cream with navy links once the page is
 * scrolled. Dawn has no equivalent, so the state is driven here.
 *
 * Only pages that actually open with a hero get the transparent treatment —
 * everywhere else the header is solid from the start, otherwise white links
 * would sit on a cream background and vanish.
 */
(function () {
  var wrapper = document.querySelector('.header-wrapper');
  if (!wrapper || !wrapper.classList.contains('header-wrapper--over-hero')) return;

  // Switch once the hero is mostly behind the header. Using a fixed offset
  // rather than the hero's height keeps this correct if the hero is swapped
  // for a shorter one in the editor.
  var TRIGGER = 80;
  var ticking = false;

  function apply() {
    var solid = window.scrollY > TRIGGER;
    wrapper.classList.toggle('is-solid', solid);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(apply);
      ticking = true;
    }
  }

  apply();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
